<template>
  <el-row>
    <el-col :span="24">
      <div class="wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <i class="el-icon-s-home" />首页
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/activity' }">科技活动</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="center_box">
          <div class="countent">
            <div class="top">
              <div class="img_box">
                <div class="NoLimits" v-if="NoLimits && DataInfo.Status != 0 && DataInfo.Status != 3 ">
                  <img @click="ToSignUp" src="../../../assets/activity/视频播放.png" alt />
                </div>
                <img class="imgCover" v-if="DataInfo.Status == 0" :src="DataInfo.Cover" alt />
                <img
                  class="imgCover"
                  v-else-if="DataInfo.Status == 1 && DataInfo.Online == ''"
                  :src="DataInfo.Cover"
                  alt
                />
                <img
                  class="imgCover"
                  v-else-if="DataInfo.Status == 2 && DataInfo.VideoUrl == ''"
                  :src="DataInfo.Cover"
                  alt
                />
                <img
                  class="imgCover"
                  v-else-if="DataInfo.Status == 3"
                  :src="DataInfo.Cover"
                  alt
                />
                <!-- :src="DataInfo.Online||DataInfo.VideoUrl" -->
                <Videotemlate
                  :src="DataInfo.VideoUrl"
                  :ID="DataInfo.ID"
                  :onlineNum="watchonlineNum"
                  :haveonline="haveonline"
                  ref="videotemlate"
                />
                <span v-show="DataInfo.Status == 0" class="yuyue">预约中</span>
                <span v-show="DataInfo.Status == 1" class="zhibo">直播中</span>
                <span v-show="DataInfo.Status == 2" class="huikna">可回看</span>
                <span v-show="DataInfo.Status == 3" class="huikna">已结束</span>
              </div>
              <div class="text_box">
                <p class="title">{{ DataInfo.Title }}</p>
                <div class="time_address">
                  <p v-if="DataInfo.ActivityStartTime">
                    报名时间：{{DataInfo.RegistrationStartTime.substring(0, 10)}}
                    至
                    {{ DataInfo.RegistrationEndTime.substring(0, 10) }}
                  </p>
                  <p v-if="DataInfo.RegistrationStartTime">
                    活动时间：{{ DataInfo.ActivityStartTime.substring(0, 10) }}
                    至
                    {{ DataInfo.ActivityEndTime.substring(0, 10) }}
                  </p>
                  <p>活动类型：{{ DataInfo.TechnologyActivityType }}</p>
                  <p>活动地点：{{ DataInfo.Place }}</p>
                </div>
                <div class="btn_box">
                  <p v-show="DataInfo.Status == 0">
                    预约人数：
                    <span>{{ DataInfo.r }}人</span>
                  </p>
                  <p v-show="(DataInfo.Status == 1 ||  DataInfo.Status == 2 || DataInfo.Status == 3) && watchonlineNum > 0">
                    累计播放次数：
                    <span>{{ watchonlineNum }}次</span>
                  </p>
                  <!-- <el-button
                    :class="{ yBaoming: this.NoLimits == false }"
                    v-show="DataInfo.Status == 0 || NoLimits"
                    @click="ToSignUp"
                    >{{ this.NoLimits ? "参会报名" : "已报名" }}</el-button
                  >
                  <el-button
                    v-show="DataInfo.Status == 1 && !NoLimits"
                    :class="{ yBaoming: DataInfo.Online == false }"
                    @click="playVideo(DataInfo.Online)"
                    >观看直播</el-button
                  >
                  <el-button
                    v-show="DataInfo.Status == 2"
                    :class="{ yBaoming: DataInfo.VideoUrl == false }"
                    @click="playVideo2(DataInfo.VideoUrl)"
                    >观看回放</el-button
                  >-->
                  <div style="margin: 0 40px"></div>
                  <el-button
                    :class="{ yBaoming: NoLimits == false }"
                    v-if="(DataInfo.Status == 0 || NoLimits) && DataInfo.Status !=3 && DataInfo.Status !=2 && DataInfo.Status !=1 "
                    @click="ToSignUp"
                  >{{ NoLimits ? "参会报名" : "已报名" }}</el-button>
                  <el-button
                    v-else-if="DataInfo.Status == 1 "
                    :class="{ yBaoming: DataInfo.Online == false }"
                    @click="playVideo(DataInfo.Online)"
                  >观看直播</el-button>
                  <el-button
                    v-else-if="DataInfo.Status == 3"
                    :class="{ yBaoming: DataInfo.Status == 3 }"
                    :disabled = "openIsDisabled" 
                  >已结束</el-button>
                  <el-button
                    v-else
                    :class="{ yBaoming: DataInfo.VideoUrl == false }"
                    @click="playVideo2(DataInfo.VideoUrl)"
                  >观看回放</el-button>
                  <el-popover
                          placement="top"
                          width="200"
                          trigger="hover">
                    <vue-qr ref="Qrcode" :logoSrc="imgUrl" :text="codeUrl" :size="200" :margin="10"></vue-qr>
                    <div slot="reference">
                      <img src="../../../assets/images/微信登录@2x.png" alt="">
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="botm">
              <el-tabs type="border-card">
                <el-tab-pane label="活动简介"  style="text-align:left">
                  <div v-html="DataInfo.Introduction"></div>
                </el-tab-pane>
                <el-tab-pane label="活动图片">
                  <div class="imgboxs">
                    <div v-for="(i, n) in imgList" :key="n" class="imgbox">
                      <img :src="i" alt />
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :show-close="false"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
      >
        <div class="head_title">
          <div class="left">参会报名</div>
          <div class="right">
            <img src="../../../assets/activity/关  闭 (1) (1).png" alt @click="handleClose" />
          </div>
        </div>
        <el-form ref="form" :model="signUpForm" :rules="rule" label-width="5rem" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="单位" prop="UnitName">
                <el-input size="medium" v-model="signUpForm.UnitName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在城市" prop="City">
                <el-row>
                  <el-col :span="11">
                    <el-select
                      size="medium"
                      v-model="signUpForm.Province"
                      placeholder="请选择"
                      @change="choosePro(item)"
                    >
                      <el-option
                        v-for="item in ProArr"
                        :key="item.ProvinceID"
                        :label="item.Name"
                        :value="item.ProvinceID"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="11">
                    <el-select
                      size="medium"
                      v-model="signUpForm.City"
                      placeholder="请选择"
                      @change="chooseCity(item)"
                    >
                      <el-option
                        v-for="item in cityArr"
                        :key="item.CityId"
                        :label="item.Name"
                        :value="item.CityId"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="Name">
                <el-input size="medium" v-model="signUpForm.Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职务" prop="Post">
                <el-input size="medium" v-model="signUpForm.Post"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="Tel">
                <el-input size="medium" v-model="signUpForm.Tel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="Email">
                <el-input size="medium" v-model="signUpForm.Email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  style="width: 52.5rem"
                  size="medium"
                  type="textarea"
                  v-model="signUpForm.Remarks"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="subData">确 定</el-button>
        </span>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import { postAction, getAction } from '@/api/api.js'
import {
  science,
  imgcommonUrl,
  pcapi,
  dockingList,
  addVisitNum,
} from '../../../api/url.js'
import qs from 'qs'
import Videotemlate from '../../../components/VideoTemplate'
import VueQr from 'vue-qr'
import wxLogo from "@/assets/images/weixinlogo.png"

export default {
  name: '',
  components: {
    Videotemlate,
    VueQr
  },
  data() {
    // 自定义验证邮箱
    var checkEmail = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/
      if (regEmail.test(value)) {
        //// console.log(regEmail.test(value));
        return callback()
      } else {
        callback(new Error('请输入合法邮箱'))
      }
    }
    // 自定义验证手机号
    var checkPhone = (rule, value, callback) => {
      //// console.log(typeof value);
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
      if (!Number.isInteger(+value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('电话号码格式不正确'))
        }
      }
    }
    return {
      haveonline: false,
      total: 1,
      dialogVisible: false,
      signUpForm: {
        UnitName: '',
        Province: null,
        City: null,
        Name: '',
        Post: '',
        Tel: '',
        Email: '',
        Remarks: '',
        proName: '',
        cityName: '',
      },
      rule: {
        UnitName: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'blur',
          },
        ],
        City: [
          {
            required: true,
            message: '请选择所在地',
            trigger: 'change',
          },
        ],
        Name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        Post: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur',
          },
        ],
        Tel: [
          {
            validator: checkPhone,
            required: true,
            message: '请输入正确手机号',
            trigger: 'blur',
          },
        ],
        Email: [
          {
            validator: checkEmail,
            required: true,
            message: '请输入正确邮箱',
            trigger: 'blur',
          },
        ],
      },
      value: '',
      options: [],
      acitiviKind: [],
      ActivityType: '',
      DataInfo: {},
      NoLimits: true,
      imgList: [],
      SignedPerson: {},
      ProArr: [],
      cityArr: [],
      watchonlineNum: 0,
      id: '',
      codeUrl: '',
      imgUrl: wxLogo,
    }
  },
  props: {},
  created() {
    this.id=this.$route.query.id
    this.codeUrl = imgcommonUrl + "/Mobile/index.html#/AcitivityDetail?id=" + this.$route.query.id
    this.loadData(this.$route.query.id)
    this.getType()
    window.setInterval(() => {
      setTimeout(this.getPeopleNum(), 0)
    }, 60000)

  },
  mounted() {
    this.ToNewsInfo()
    this.$bus.$on('LoginSuccess', (e) => {
      if (e) {
        setTimeout(() => {
          this.IsSignup()
        }, 500)
      }
    })
    this.addmannum()
    this.getPeopleNum()
  },

  methods: {
    ToNewsInfo() {
      //判断是否是PC设备，true是，false不是
         //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      // console.log(navigator.userAgent)
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        // console.log(userAgentInfo.indexOf(Agents[j]))
        if (userAgentInfo.indexOf(Agents[j])>0) {
          flag = false
          break
        }
      }
      // console.log(window.screen.width)
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        this.$router.push({
          path: '/activityDetail',
          query: { id: this.id },
        })
      } else {
        console.log(this.Urls,'ddddd')
        window.location.href=this.Urls+'/Mobile/index.html#/AcitivityDetail?id=' +
            this.id
        
      }
    },
    // 获取观看直播人数
    getPeopleNum() {
      let vm = this
      let data = {
        action: 'Get_SpecialVisits',
        ID: this.$route.query.id,
      }
      postAction(dockingList, qs.stringify(data)).then((res) => {
        // console.log(res)
        this.watchonlineNum = res
      })
    },
    // 进入页面人数加一
    addmannum() {
      let vm = this
      let data = {
        action: 'Update_Hits',
        ID: this.$route.query.id,
      }
      postAction(addVisitNum, qs.stringify(data)).then((res) => {
        // console.log(res)
        // this.watchonlineNum = res;
      })
    },

    playVideo(val) {
      if (!val) return
     
      let userid = localStorage.getItem('RealID')

       if (!userid) {
        this.signUp()
        return false
      } else
      {
        this.NoLimits = false
      }
       this.$refs.videotemlate.operateEvent()
    },
    playVideo2(val) {
      if (!val) return
      let userid = localStorage.getItem('RealID')
      if (!userid) {
        this.signUp()
        return false
      } 
      else
      {
        this.NoLimits = false
      }
      this.$refs.videotemlate.operateVideo()
    },
    choosePro(a) {
      this.signUpForm.proName = a.Name.trim()
    },
    chooseCity(a) {
      this.signUpForm.cityName = a.Name.trim()
    },
    // 提交
    subData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            TechnologyActivityID: this.$route.query.id,
            UserID: localStorage.getItem('RealID'),
            UnitName: '',
            Place: '',
            PlaceName: '',
            Name: '',
            Post: '',
            Tel: '',
            Email: '',
            Remarks: '',
          }
          data.Place = `${this.signUpForm.Province}-${this.signUpForm.City}`
          if (this.signUpForm.proName == '') {
            this.ProArr.map((item) => {
              if (this.signUpForm.Province == item.ProvinceID) {
                this.signUpForm.proName = item.Name.trim()
              }
            })
          }
          if (this.signUpForm.cityName == '') {
            this.cityArr.map((item) => {
              if (this.signUpForm.City == item.CityId) {
                this.signUpForm.cityName = item.Name.trim()
              }
            })
          }
          data.PlaceName = `${this.signUpForm.proName}-${this.signUpForm.cityName}`
          data.Remarks = this.signUpForm.Remarks
          data.Email = this.signUpForm.Email
          data.Tel = this.signUpForm.Tel
          data.Name = this.signUpForm.Name
          data.Post = this.signUpForm.Post
          data.UnitName = this.signUpForm.UnitName

          let a = {
            action: 'Sign_Up',
            DataInfo: JSON.stringify(data),
          }

          postAction(science, qs.stringify(a)).then((res) => {
            //// console.log(res);
            if (res.status == '0') {
              this.$message.success(res.errMsg)
              this.dialogVisible = false
              this.NoLimits = false
            } else {
              this.$message.error(res.errMsg)
            }
          })
        }
      })
    },
    // 获取省市
    getProvince() {
      //// console.log(11111);
      let data = {
        action: 'Get_Province',
      }
      postAction(pcapi, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.ProArr = res
        }
      })
    },
    getCity() {
      let data = {
        action: 'Get_City',
        ProvinceID: this.signUpForm.Place[0],
      }
      postAction(pcapi, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.cityArr = res
        }
      })
    },
    getType() {
      getAction(science, {
        action: 'Cet_Type',
      }).then((res) => {
        this.acitiviKind = res
        //// console.log(this.acitiviKind);
      })
    },

    loadData(id) {
      let data = {
        action: 'Get_TechnologyActivity',
        ID: id,
      }
      postAction(science, this.$qs.stringify(data)).then((res) => {
        this.DataInfo = res[0]
        // console.log('科技活动详情页', this.DataInfo)
        this.DataInfo.Img.split('|').forEach((item) => {
          if (item !== '') {
            let imgs = imgcommonUrl + '/' + item
            this.imgList.push(imgs)
          }
        })

        setTimeout(() => {
          this.acitiviKind.forEach((item) => {
            //// console.log(item);
            if (item.ID == res.Type) {
              this.ActivityType = item.Title
              //// console.log(this.ActivityType);
            }
          })
        }, 200)
        setTimeout(() => {
          this.IsSignup()
        }, 500)
      })
    },
    getCardData() {},

    signUp() {
      let userId = localStorage.getItem('RealID')
      if (userId) {
        this.IsSignup()
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {})
      }
      // this.dialogVisible = true;
    },
    IsSignup() {
      let userId = localStorage.getItem('RealID')
      //// console.log(localStorage.getItem("RealID"));

      if (!userId) {
        return false
      }
      if(this.DataInfo.Status ==2 || this.DataInfo.Status ==1)
      {
        this.NoLimits = false
      }
      else
      {
      let data = {
        action: 'Is_SignUp',
        UserId: userId,
        ID: this.DataInfo.ID,
      }
      getAction(science, data).then((res) => {
        if (res.state == 'y') {
          this.NoLimits = false
        } else {
          this.NoLimits = true
        }
      })
    }
    },
    handleClose() {
      this.dialogVisible = false
      //// console.log(this.dialogVisible)
    },
    // 报名 （登录状态和未报名状态  ）

    ToSignUp() {
      // //// console.log(this.dialogVisible)
      // this.dialogVisible = true;
      // //// console.log(this.dialogVisible)
      let userid = localStorage.getItem('RealID')
      if (!userid) {
        this.signUp()
        return false
      } else {
        if (!this.NoLimits) return
        let data = {
          action: 'Get_Info',
        }
        getAction(science, data).then((res) => {
          //// console.log(res);
          this.SignedPerson = res[0]
          this.signUpForm.UnitName = this.SignedPerson.Company
          this.signUpForm.Name = this.SignedPerson.RealName
          this.signUpForm.Tel = this.SignedPerson.Telephone
          this.signUpForm.Email = this.SignedPerson.Email
          //// console.log(this.SignedPerson.Province);
          // this.SignedPerson.Province = "15-70";
          if (this.SignedPerson.Province) {
            let a = this.SignedPerson.Province.split('-')
            this.signUpForm.Place = a
            a[0] = Number(this.signUpForm.Place[0])
            a[1] = Number(this.signUpForm.Place[1])
            this.signUpForm.Province = a[0]
            this.signUpForm.City = a[1]
          }

          this.getProvince()
          this.getCity()
          //// console.log(this.signUpForm.Place);
          setTimeout(() => {
            this.dialogVisible = true
            //// console.log(this.dialogVisible)
          }, 100)

          // this.dialogVisible = true;
          // //// console.log(this.dialogVisible)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  background: url('../../../assets/activity/组 3826.png') no-repeat;
  background-size: 100% auto;
}

/deep/.el-form-item__error {
  color: #f56c6c;
  font-size: 0.75rem;
  line-height: 1;
  padding-top: 0.25rem;
  position: absolute;
  top: 100%;
  left: 1.875rem;
}

/deep/ .el-breadcrumb {
  width: 86.25rem;
  margin: 0 auto;
  padding: 1.25rem;
  color: #fff;

  .el-breadcrumb__inner {
    color: #fff !important;
  }
}

.center_box {
  width: 87.5rem;
  //   height: 87.5rem;
  background: #ffffff;
  opacity: 1;
  border-radius: 0rem;
  margin: 0 auto;
}

.countent {
  .top {
    padding: 1.25rem 1.25rem;
    box-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.06);
    display: flex;

    .img_box {
      width: 46.875rem;
      height: 25.3125rem;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        vertical-align: bottom;
      }

      span {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        padding: 0.3125rem 0.625rem;
        border-radius: 0.125rem;
        position: absolute;
        top: 0.375rem;
        right: 0.3125rem;
        position: absolute;
        top: 0.4375rem;
        right: 0.3125rem;
      }

      .yuyue {
        background-color: #2d8bff;
      }

      .zhibo {
        background-color: #ff9e57;
      }

      .huikna {
        background-color: #10c2b0;
      }

      .bofang {
        width: 5rem;
        height: 5rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .text_box {
      width: 35.9375rem;
      display: flex;
      flex-direction: column;
      text-align: left;
      padding: 0 1.875rem;

      .title {
        font-size: 1.625rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        opacity: 1;
      }

      .time_address {
        padding: 2.5rem 0;

        p {
          padding: 0.625rem 0;
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
        }
      }

      .btn_box {
        margin-top: 4.5rem;
        height: 3.125rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 1.0625rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
        }

        span {
          color: #ff9e57;
        }

        /deep/ .el-button--default {
          width: 9.75rem;
          height: 3.125rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 0.25rem;

          span {
            height: 1.375rem;
            font-size: 1.0625rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 0px;
            color: #ffffff;
          }
        }
      }
    }
  }

  .botm {
    margin-top: 1.5625rem;
    margin-bottom: 5rem;

    /deep/ .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        width: 50%;
        font-size: 1.5rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        opacity: 1;
        border: none;
        height: 4rem;
        line-height: 4rem;
      }

      .is-active {
        font-size: 1.5rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2769dc;
        opacity: 1;
        border-top: 0.1875rem solid #2769dc;
      }
    }
  }
}

/deep/ .el-dialog {
  max-width: 63.8125rem;
}

/deep/ .el-form-item__content {
  .el-input__inner {
    width: 21.875rem;
    height: 2.875rem;
    background: #ffffff;
    // border: 0.0625rem solid rgba(51, 51, 51, 0.16078431372549018);
    line-height: 2.875rem;
    opacity: 1;
    border-radius: 0.1875rem;
  }

  .el-select {
    margin-left: 1.5625rem;

    .el-input__inner {
      max-width: 10.625rem;
      height: 2.875rem;
      background: #ffffff;
      border: 0.0625rem solid rgba(51, 51, 51, 0.16078431372549018);
      opacity: 1;
      border-radius: 0.1875rem;
    }
  }
}

/deep/ .el-textarea__inner {
  max-height: 5.75rem;
}

/deep/ .el-dialog__header {
  display: none;
}

.head_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3.4375rem;

  .left {
    font-size: 1.75rem;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 2.9375rem;
    color: #333333;
    opacity: 1;
    background: url('../../../assets/activity/组 23133.png') no-repeat;
    background-position: bottom;
  }
}

.NoLimits {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1111;

  img {
    width: 3.125rem !important;
    margin-top: 10.9375rem;
    cursor: pointer;
  }
}

.imgboxs {
  margin-top: 4.75rem;
  margin-bottom: 12rem;
  /* margin-left: 1rem; */
  display: flex;
  flex-wrap: wrap;
  justify-content: inherit;

  .imgbox {
    width: 26.25rem;
    height: 18.1875rem;
    padding: 1rem;

    img {
      margin-right: 1.875rem;
      margin-bottom: 1.875rem;
      width: 100%;
    }
  }
}

.countent .top .text_box .btn_box .yBaoming {
  background: #ccc !important;
  border: none;
}

.imgCover {
  width: 46.875rem;
  height: 25.3125rem;
}
</style>
